import '../styles/footer.css';
import { Link, useLocation } from 'react-router-dom';
import { useContext } from 'react';
import { SiteContentContext } from '../context/SiteContentContext';
import { useGeo, coordsMapUrl } from '../context/GeoContext';
import iymcsBadge from '../assets/iymcs-footer-badge.png';

const Footer = () => {
  const { content } = useContext(SiteContentContext);
  const country = useGeo();
  const location = useLocation();
  const isPreview = location.pathname.startsWith('/preview');
  const p = (path) => isPreview ? `/preview${path}` : path;
  const showInstagram = country !== null && country !== 'RU' && country !== 'BY';

  const toDDM = (deg, isLat) => {
    const d = Math.floor(Math.abs(deg));
    const m = ((Math.abs(deg) - d) * 60).toFixed(2);
    const dir = isLat ? (deg >= 0 ? 'N' : 'S') : (deg >= 0 ? 'E' : 'W');
    return `${d}°${m}'${dir}`;
  };

  const coords = content.coordinates
    ? content.coordinates.split(',').map(Number)
    : null;

  return (
    <footer className="app-footer">
      <div className="footer-inner">
        <div className="footer-top">
          <span className="footer-name">{content.schoolName || 'Dr. Sailing'}</span>

          <div className="footer-icons">
            {content.email && (
              <a href={`mailto:${content.email}`} className="footer-icon-link" title={content.email} aria-label="Email">
                <svg viewBox="0 0 24 24"><path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg>
              </a>
            )}
            {content.instagram && showInstagram && (
              <a href={content.instagram} target="_blank" rel="noopener noreferrer" className="footer-icon-link" title="Instagram" aria-label="Instagram">
                <svg viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
              </a>
            )}
            {content.telegram && (
              <a href={content.telegram} target="_blank" rel="noopener noreferrer" className="footer-icon-link" title="Telegram" aria-label="Telegram">
                <svg viewBox="0 0 24 24"><path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm5.894 8.221l-1.97 9.28c-.145.658-.537.818-1.084.508l-3-2.21-1.446 1.394c-.14.18-.357.295-.6.295l.213-3.054 5.56-5.022c.24-.213-.054-.334-.373-.121l-6.869 4.326-2.96-.924c-.64-.203-.658-.64.135-.954l11.566-4.458c.538-.196 1.006.128.832.941z"/></svg>
              </a>
            )}
            {coords && (
              <a href={coordsMapUrl(content.coordinates, country)} target="_blank" rel="noopener noreferrer" className="footer-icon-link" title={`${toDDM(coords[0], true)}, ${toDDM(coords[1], false)}`} aria-label="Карта">
                <svg viewBox="0 0 24 24"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/></svg>
              </a>
            )}
            <Link to="/privacy" className="footer-icon-link" title="Политика конфиденциальности" aria-label="Политика конфиденциальности">
              <svg viewBox="0 0 24 24"><path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 4l6 2.67V11c0 3.53-2.45 6.86-6 7.93-3.55-1.07-6-4.4-6-7.93V7.67L12 5zm-1 4v2H9v2h2v2h2v-2h2v-2h-2V9h-2z"/></svg>
            </Link>
          </div>

          <Link to={p('/iymcs')} className="footer-iymcs-badge" title="Курсы IYMCS" aria-label="IYMCS">
            <img src={iymcsBadge} alt="Powered by the IYMCS course system" />
          </Link>
        </div>

        <div className="footer-bottom">
          <span>© {new Date().getFullYear()} {content.schoolName || 'Dr. Sailing'} — {content.schoolSubtitle || 'Парусная школа'}</span>
          <Link to="/privacy" className="footer-privacy">Политика конфиденциальности</Link>
          <button
            className="footer-cookie-reset"
            onClick={() => { localStorage.removeItem('cookie_consent'); window.location.reload(); }}
          >
            Настройки cookie
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
